import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash, FaPlus, FaFilePdf } from "react-icons/fa";
import jsPDF from "jspdf";
import "./JamaKarnaryachiMahiti.css";

const JamaKarnaryachiMahiti = () => {
  const [name, setName] = useState("");
  const [list, setList] = useState(() => {
    const savedList = localStorage.getItem("grampanchayat_jama_karnary");
    return savedList
      ? JSON.parse(savedList)
      : [{ id: 1, name: "संग्राम शिंदे" }];
  });
  const [editId, setEditId] = useState(null);

  // Save to localStorage whenever list changes
  useEffect(() => {
    localStorage.setItem("grampanchayat_jama_karnary", JSON.stringify(list));
  }, [list]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("❌ नाव टाका!");
      return;
    }

    if (editId) {
      setList(
        list.map((item) =>
          item.id === editId ? { ...item, name } : item
        )
      );
      setEditId(null);
      alert("✅ माहिती यशस्वीरित्या अपडेट झाली!");
    } else {
      setList([...list, { id: Date.now(), name }]);
      alert("✅ जमा करणारा यशस्वीरित्या जोडला गेला!");
    }

    setName("");
  };

  const handleEdit = (item) => {
    setName(item.name);
    setEditId(item.id);
  };

  const handleDelete = (id) => {
    if (window.confirm("❓ हा जमा करणारा हटवायचा आहे का?")) {
      setList(list.filter((item) => item.id !== id));
      alert("✅ जमा करणारा यशस्वीरित्या हटवला गेला!");
    }
  };

  const handleCancel = () => {
    setName("");
    setEditId(null);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Add header with color background
    doc.setFillColor(102, 126, 234);
    doc.rect(0, 0, pageWidth, 30, "F");

    // Title
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(18);
    doc.setFont("Arial", "bold");
    doc.text("जमा करणाऱ्याची माहिती", pageWidth / 2, 15, { align: "center" });
    doc.setFont("Arial", "normal");
    doc.setFontSize(10);
    doc.text(
      "Payer Information Report",
      pageWidth / 2,
      22,
      { align: "center" }
    );

    // Reset colors for body
    doc.setTextColor(0, 0, 0);

    // Add metadata
    doc.setFontSize(10);
    doc.setFont("Arial", "normal");
    const date = new Date().toLocaleDateString("mr-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const time = new Date().toLocaleTimeString("mr-IN");
    doc.text(`दिनांक: ${date}`, 15, 40);
    doc.text(`वेळ: ${time}`, 15, 47);
    doc.text(`एकूण रेकॉर्ड: ${list.length}`, 15, 54);

    // Create table manually
    let yPosition = 65;
    const tableHeaders = ["क्र.", "जमा करणाऱ्याचे नाव"];
    const colWidths = [30, 150];

    // Draw header
    doc.setFillColor(102, 126, 234);
    doc.setTextColor(255, 255, 255);
    doc.setFont("Arial", "bold");
    let xPosition = 15;
    
    tableHeaders.forEach((header, i) => {
      doc.rect(xPosition, yPosition - 8, colWidths[i], 8, "F");
      doc.text(header, xPosition + colWidths[i] / 2, yPosition - 2, {
        align: "center",
      });
      xPosition += colWidths[i];
    });

    // Draw rows
    doc.setTextColor(0, 0, 0);
    doc.setFont("Arial", "normal");
    yPosition += 3;

    list.forEach((item, index) => {
      yPosition += 8;
      xPosition = 15;

      // Alternate row color
      if (index % 2 === 0) {
        doc.setFillColor(240, 243, 255);
        doc.rect(xPosition, yPosition - 8, 180, 8, "F");
      }

      // Row border
      doc.setDrawColor(200, 200, 200);
      doc.rect(xPosition, yPosition - 8, 180, 8);

      // Data
      doc.text((index + 1).toString(), xPosition + 15, yPosition - 2, {
        align: "center",
      });
      doc.text(item.name, xPosition + colWidths[0] + 5, yPosition - 2);

      // Check page break
      if (yPosition > pageHeight - 20) {
        doc.addPage();
        yPosition = 20;
      }
    });

    // Footer
    const totalPages = doc.internal.pages.length - 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(
        `पृष्ठ ${i}`,
        pageWidth / 2,
        pageHeight - 10,
        { align: "center" }
      );
    }

    // Download
    doc.save("jama-karnaryachi-mahiti.pdf");
  };

  return (
    <div className="jama-container">
      {/* HEADER */}
      <div className="jama-header">
        <h3 className="jama-title">👤 जमा करणाऱ्याची माहिती</h3>
      </div>

      {/* FORM */}
      <div className="jama-card">
        <form onSubmit={handleSubmit} className="jama-form">
          <div className="jama-field">
            <label className="jama-label">
              जमा करणाऱ्याचे नाव <span className="jama-required">*</span>
            </label>

            <input
              type="text"
              placeholder="पूर्ण नाव टाका..."
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="jama-input"
              required
            />
          </div>

          <div className="jama-btn-row">
            <button type="submit" className="jama-btn-save">
              <FaPlus /> {editId ? "अपडेट करा" : "जोडा"}
            </button>
            {editId && (
              <button
                type="button"
                onClick={handleCancel}
                className="jama-btn-cancel"
              >
                रद्द करा
              </button>
            )}
          </div>
        </form>
      </div>

      {/* TABLE */}
      <div className="jama-card">
        <div className="jama-table-header">
          <span className="jama-count">एकूण : {list.length}</span>
          {list.length > 0 && (
            <button
              onClick={handleDownloadPDF}
              className="jama-btn-pdf"
              title="PDF डाउनलोड करा"
            >
              <FaFilePdf /> PDF
            </button>
          )}
        </div>

        <div className="jama-table-wrapper">
          <table className="jama-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>जमा करणाऱ्याचे नाव</th>
                <th style={{ width: "150px" }}>क्रिया</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 ? (
                <tr>
                  <td colSpan="3" className="jama-no-data">
                    📭 कोणतीही माहिती उपलब्ध नाही
                  </td>
                </tr>
              ) : (
                list.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.name}</td>
                    <td className="jama-actions">
                      <button
                        className="jama-btn-icon jama-btn-edit"
                        onClick={() => handleEdit(item)}
                        title="संपादन करा"
                      >
                        <FaEdit /> संपादन
                      </button>
                      <button
                        className="jama-btn-icon jama-btn-delete"
                        onClick={() => handleDelete(item.id)}
                        title="हटवा"
                      >
                        <FaTrash /> हटवा
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default JamaKarnaryachiMahiti;
